import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-recent-chat-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './recent-chat-card.component.html',
  styleUrls: ['./recent-chat-card.component.css'],
})
export class RecentChatCardComponent {
  @Input({ required: true }) chat: any;
  @Input() question: string = '';
  @Input() agentShortName: string = '';
  @Input() agentBadgeClasses: string = '';
  @Input() dateLabel: string = '';
  @Input() onOpen?: (chat: any) => void;
}
